import { FC } from 'react';
import _ from 'lodash';
import ErrorMesssage from 'common/components/ErrorMesssage';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import UserInput from 'v3/common/components/UserInput';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import Button from 'v3/common/components/Button';

const TradeSmart: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles }) => {
  const { updatePartialConfigs, sendOtp, reDirectPage, isMobile } = brokerSpecificHandles;
  const { clientId, password, otp, selectedBrokerConfig, isOtpSent, isLoading, brokerErrorMessage } =
    userConfigs;

  const broker = selectedBrokerConfig?.id;

  return (
    <form
      id={`${broker}-otp-form`}
      onSubmit={(e) => {
        e.preventDefault();
        return isOtpSent ? reDirectPage() : sendOtp();
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client Id"
        id={`${broker}-client-id`}
        value={clientId}
        isDisabled={isOtpSent}
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />
      <UserInput
        labelValue="Password"
        id={`${broker}-password`}
        value={password}
        isDisabled={isOtpSent}
        type="password"
        onHandleChange={(value) => updatePartialConfigs({ password: value })}
      />
      {isOtpSent && (
        <button className="btn btn-link btn-sm" type="button" onClick={() => sendOtp(true)}>
          <i className="fa-regular fa-gear fa-spin" />
          Re-send OTP ?
        </button>
      )}

      {isOtpSent && (
        <div className="mt-2">
          <label>OTP/DOB/PAN</label>
          <UserInput
            id={`${broker}-otp`}
            value={otp ?? ''}
            onHandleChange={(value) => updatePartialConfigs({ otp: _.toNumber(value) })}
          />
        </div>
      )}

      <ErrorMesssage error={{ message: brokerErrorMessage }} />
      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-otp-form`} type="submit" isLoading={isLoading}>
          {isOtpSent ? 'Login' : 'Send OTP'}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default TradeSmart;
